import { grays } from '@airwallex/colors';
import styled from '@emotion/styled';

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${grays[20]};
`;
